<script setup>
import store from "@/store";
import ModalAlert from "@/components/common/ModalAlert.vue";
import { computed } from "vue";

const modalAlert = computed(() => store.state.modalAlert);
</script>

<template>
  <Teleport to="#app">
    <ModalAlert
      :show="modalAlert.showModal"
      @close="store.commit('closeModalAlert')"
    >
      <template #body>
        <div v-html="modalAlert.message"></div>
      </template>
    </ModalAlert>
  </Teleport>

  <headerPage />
  <router-view />
</template>
